var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M0,248.1C0,111.1,111.1,0,248.1,0s248.1,111.1,248.1,248.1S385.1,496.2,248.1,496.2S0,385.1,0,248.1z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.6,378.7c0,6.8-5.5,12.3-12.3,12.3h-48.6c-6.8,0-12.3-5.5-12.3-12.3v-83.6 c0-6.8,5.5-12.3,12.3-12.3h48.6c6.8,0,12.3,5.5,12.3,12.3V378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M277.4,378.7c0,6.8-5.5,12.3-12.3,12.3h-48.6c-6.8,0-12.3-5.5-12.3-12.3V234.4 c0-6.8,5.5-12.3,12.3-12.3h48.6c6.8,0,12.3,5.5,12.3,12.3V378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.9,378.7c0,6.8-5.5,12.3-12.3,12.3H321c-6.8,0-12.3-5.5-12.3-12.3V173.6 c0-6.8,5.5-12.3,12.3-12.3h48.6c6.8,0,12.3,5.5,12.3,12.3V378.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289,82c0,7.8-8.9,13.4-9.4,12.7c-6.6-7.7-18-13.4-29.5-13.4c-11.7,0-18.8,5.2-18.8,13.1 c0,9.1,9.6,11.5,23,14.5c16,3.5,37.1,9.9,37.1,32.8c0,17.6-12.2,29.8-32.6,33v6.8c0,8-3.1,11.9-10.1,11.9h-0.9 c-7.3,0-9.9-3.7-9.9-11.9v-6.4c-21.1-2.3-33.1-11.9-33.1-21.6c0-7.5,8.4-12.9,9.1-12.2c6.6,8,19.5,14.6,33.1,14.6 c12.4,0,19.5-5.2,19.5-13.1c0-9.6-10.8-12.2-23.5-15.2c-15.3-3.3-35.6-9.4-35.6-32.4c0-16.7,11.9-28.8,30.7-32.2v-6.5 c0-8,3-11.9,9.9-11.9h1c7.1,0,9.9,3.7,9.9,11.9v5.9C278.3,64.4,289,73.1,289,82z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.e882b9bc7c21fa6c5f4c0a8135aef03a.svg";
export { ForwardRef as ReactComponent };